<template>
  <div class="space-y-8">
    <div v-if="assets.length" key="assets" class="grid grid-cols-3 gap-4">
      <ConvertableAsset
        v-for="asset in assets"
        :key="asset.id"
        :order-item-id="orderItemId"
        :asset="asset"
        @created="$emit('created', $event)"
      />
    </div>
    <div v-else-if="pending" key="pending" class="text-center">
      <Loader />
    </div>
    <div v-else key="empty" class="text-center text-lg font-medium">No assets found!</div>
    <div v-if="meta" class="text-center">
      <BaseButton
        v-if="meta.last_page > meta.current_page"
        primary
        :disabled="pending"
        @click="fetchAssets({ page: meta.current_page + 1 })"
      >
        Load more
      </BaseButton>
    </div>
  </div>
</template>

<script>
import ConvertableAsset from './ConvertableAsset.vue';

export default {
  name: 'OwnedAssetList',
  components: {
    ConvertableAsset,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
    };
  },
  computed: {
    assets() {
      return this.$store.getters['ui/accountAssets/itemsByParent'](this.accountId);
    },
    meta() {
      return this.$store.state.ui.accountAssets.meta;
    },
  },
  created() {
    this.fetchAssets();
  },
  destroyed() {
    this.$store.dispatch({
      type: 'ui/accountAssets/clear',
      accountId: this.accountId,
    });

    this.$store.commit('ui/accountAssets/setMeta', null);
    this.$store.commit('ui/accountAssets/setLinks', null);
  },
  methods: {
    async fetchAssets(params = {}) {
      try {
        this.pending = true;
        await this.$store.dispatch({
          type: 'ui/accountAssets/load',
          accountId: this.accountId,
          params: {
            ...params,
            include: 'assetable,tags',
            filter: this.filters,
          },
        });
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
